import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import {
  BUNDLE_STEP,
  PATTERN_STEP,
  SIZE_STEP,
  UPSELL_STEP
} from '../utils/bab/bab.utils'

import Navigation from '../components/navigation/navigation.component'
import RouteGuard from '../components/route-guard/route-guard.component'
import Bundle from '../routes/bundle/bundle.component'
import Size from '../routes/size/size.component'
import Pattern from '../routes/pattern/pattern.component'
import Upsell from '../routes/upsell/upsell.component'
import Reassurance from '../components/reassurance/reassurance.component'

import '../assets/css/general.scss'

const App = () => {
  return (
    <Router>
      <Navigation />
      <div id='newBAB'>
        <div className='bab-step'>
          <RouteGuard>
            <Switch>
              <Route exact path={SIZE_STEP.path}>
                <Size />
              </Route>
              <Route exact path={BUNDLE_STEP.path}>
                <Bundle />
              </Route>
              <Route exact path={PATTERN_STEP.path}>
                <Pattern />
              </Route>
              <Route exact path={UPSELL_STEP.path}>
                <Upsell />
              </Route>
            </Switch>
            <Reassurance location={'routes'} margins={[24, 0]} />
          </RouteGuard>
        </div>
      </div>
    </Router>
  )
}

export default App
